import AbstractGuestlistDetailsPageController from './abstract-details-controller';

export default class GuestlistPublicSeatsPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.navService = this.injector.get('NavService');
        this.filter = this.injector.get('$filter');

        this.loading = true;
        this.guestlist = null;
        this.seatplan = null;

        this.publicBookableElements = {};
        this.blockedElements = [];
        this.currentSelectedElements = [];
        this.bookingInformation = {};

        this.currentGroup = false;
    }

    // Public functions
    activateGroup(group) {
        this.currentGroup = group.id;
        this._updateCustomActions();
        if (this.publicBookableElements[group.id]) {
            this.currentSelectedElements = this.publicBookableElements[group.id];
        } else {
            this.currentSelectedElements = [];
        }
    }

    save() {
        this.loading = true;

        return this.api
            .put(
                `guestlists/${this.guestlist.id}/seatplan/public-elements`,
                this._prepareDataForSaving()
            )
            .then((response) => {
                this.publicBookableElements = response.data;
                this.loading = false;
                this.alert.success('Success', 'Public seats have been saved.');
            })
            .catch(() => {
                this.alert.error('Error', 'Error while saving public seats.')
            });
    }

    handleSeatplanSelectionChange(triggeredElement, selectionState, allSelectedElements) {
        this.scope.$applyAsync(() => {
            this.publicBookableElements[this.currentGroup] = [];
            _.each(allSelectedElements, (element) => {
                this.publicBookableElements[this.currentGroup].push(element.id);
            });

            this.currentSelectedElements = this.publicBookableElements[this.currentGroup];
        });
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this.loading = true;


        this.blockedElements = [];
        _.forEach(this.guestlist.blockedSeatplanElements.data, (val) => {
            this.blockedElements.push(val.id);
        });

        this.injector
            .get('$q')
            .all([
                this.api
                    .get(`seatplans/${this.guestlist.seatplan_id}?include=groups,areas`)
                    .then(({data}) => {
                        this.seatplan = _.cloneDeep(data.data)
                        this.loading = false;
                    }),
                this._updateAlreadyDefinedPublicElements()
            ])
            .then(() => {
                this.activateGroup(this.seatplan.groups.data[0]);
                this._updateCustomActions();
                this.loading = false;
            });
    }

    // Internal functions
    _updateAlreadyDefinedPublicElements() {
        return this.api.get('guestlists/' + this.stateParams.gid + '/seatplan/public-elements').then((response) => {
            this.publicBookableElements = response.data;
        });
    }

    _prepareDataForSaving() {
        const out = {
            'bookable-elements': []
        };

        _.each(this.publicBookableElements, (elementIds) => {
            if (_.isArray(elementIds) && elementIds.length > 0) {
                out['bookable-elements'] = out['bookable-elements'].concat(elementIds);
            }
        });

        return out;
    }

    _updateCustomActions() {
        this.navService.shouldShowBackBtn(false);
        const customs = [];
        _.each(this.seatplan.groups.data, (group) => {
            customs.push({
                label: group.title,
                key: 'group-' + group.id,
                icon: 'char-' + group.title[0].toLowerCase(),
                order: group.title[0].toLowerCase(),
                action: () => {
                    this.activateGroup(group);
                },
                active: group.id === this.currentGroup
            });
        });

        this.navService.setSideNavCustoms(customs);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/public-seats-controller.js